import React from "react";
import './skeleton.css'

const RenderComponent = () => {
  return (
    <div className="flex w-full py-4">
      <div className="w-[14%] flex flex-col gap-4">
        <div class="line w-[12rem] h-[0.8rem] rounded-md"></div>{" "}
      </div>
      <div className="w-[9%]">
        <div class="line w-[6rem] h-[0.8rem] rounded-md"></div>
      </div>
      <div className="w-[5%]">
        <div class="line w-[7rem] h-[0.8rem] rounded-md"></div>
      </div>
      <div className="w-[10%] ml-[4%]">
        <div class="line w-[5rem] h-[0.8rem] rounded-md"></div>
      </div>
      <div className="w-[10%] ml-[2%]">
        <div class="line w-[5rem] h-[0.8rem] rounded-md"></div>
      </div>
      <div className="w-[25%]">
        <div class="line w-[19.5rem] h-[0.8rem] rounded-md"></div>
      </div>
      <div className="w-[8%] ml-[12%]">
        <div class="line w-[1rem] h-[1.2rem] rounded-md"></div>
      </div>
    </div>
  );
};

export default RenderComponent;
